import instance,{BASE_URL}from "../../services/api";
import toast from 'react-hot-toast';

const DocumentViewController =() =>{
  const getErrorMessage = (error) => {
  return (
    error.response?.data?.detail ||   // Django REST Framework style
    error.response?.data?.message ||  // custom backend message
    error.response?.data?.error ||    // another fallback
    error.message ||                  // Axios default
    "Something went wrong!"
  );
};

    const getEmployeeForGenrateDocument = () => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await instance.get(
        `${BASE_URL}employees/generate-letters/`,
        {}
      );
      // console.log("Fetching attendance with params:", params);

      const jsonString = JSON.stringify(response.data);
      const data = JSON.parse(jsonString);
      // console.log("Fetched attendance data:", response.data);
      dispatch({ type: "GET_EMPLOYEE_FOR_DOCUMENTS_SUCCESS", payload: data });
      dispatch({ type: "LOADING", payload: false });
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
       const message = getErrorMessage(error);
      dispatch({
        type: "GET_EMPLOYEE_FOR_DOCUMENTS_FAILURE",
        payload: { error: error }
      });
      toast.error(message);
    }
  };
  
  // actions/DocumentApiAction.js
const getInternshipLetter = (employeeId, first, last, query) => async (dispatch) => {
  dispatch({ type: "LOADING", payload: true });
  try {
    const qs = new URLSearchParams(query).toString(); // build ?key=value&...
    const response = await instance.get(
      `${BASE_URL}internship-letter/${employeeId}/?${qs}`,
      { responseType: "blob" }
    );

    const fileURL = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = fileURL;
    link.setAttribute("download", `Internship_letter_${first}_${last}.pdf`);
    document.body.appendChild(link);
    link.click();
    link.remove();

    dispatch({
      type: "GET_INTERNSHIP_LETTER_SUCCESS",
      payload: "Internship letter downloaded successfully",
    });
  } catch (error) {
    dispatch({ type: "GET_INTERNSHIP_LETTER_FAILURE", payload: false });
    dispatch({ type: "ERROR", payload: "Failed to generate internship letter" });
  }
};

 const getRelievingLetter = (employeeId, first, last, { closing_date, supervisor_name, designation }) => async (dispatch) => {
  dispatch({ type: "LOADING", payload: true });
  try {
    const response = await instance.get(
      `${BASE_URL}relieving-letter/${employeeId}/?closing_date=${encodeURIComponent(closing_date)}&supervisor_name=${encodeURIComponent(supervisor_name)}&designation=${encodeURIComponent(designation)}`,
      { responseType: "blob" }
    );

    const fileURL = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = fileURL;
    link.setAttribute("download", `Relieving_letter_${first}_${last}.pdf`);
    document.body.appendChild(link);
    link.click();
    link.remove();

    dispatch({ type: "GET_RELIEVING_LETTER_SUCCESS", payload: "Relieving letter downloaded successfully" });
  } catch (error) {
    dispatch({ type: "GET_RELIEVING_LETTER_FAILURE", payload: false });
    dispatch({ type: "ERROR", payload: "Failed to generate relieving letter" });
    console.error("Error generating relieving letter:", error);
  }
};



  // actions/DocumentApiAction.js
const getExperianceLetter = (employeeId, first, last, query) => async (dispatch) => {
  dispatch({ type: "LOADING", payload: true });

  try {
    // Build query string
    const params = new URLSearchParams(query).toString();
    const response = await instance.get(
      `${BASE_URL}experience-letter/${employeeId}/?${params}`,
      {
        responseType: "blob",
      }
    );

    const fileURL = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = fileURL;
    link.setAttribute("download", `Experience_letter_${first}_${last}.pdf`);
    document.body.appendChild(link);
    link.click();
    link.remove();

    dispatch({
      type: "GET_EXPERIANCE_LETTER_SUCCESS",
      payload: "Experience letter downloaded successfully",
    });
  } catch (error) {
    dispatch({ type: "GET_EXPERIANCE_LETTER_FAILURE", payload: false });
    console.error("Error generating experience letter:", error);
    dispatch({ type: "ERROR", payload: "Failed to generate experience letter" });
  }
};

  const getJoiningLetter = (employeeId,first,last) => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });

    try {
      const response = await instance.get(
        `${BASE_URL}joining-letter/${employeeId}/`,
        {
          responseType: "blob", // Important to handle PDF
        }
      );
      
      const fileURL = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = fileURL;
      link.setAttribute("download", `Joining_letter_${first}_${last}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();

      dispatch({
        type: "GET_INTERNSHIP_LETTER_SUCCESS",
        payload: "Payslip downloaded successfully",
      });
    } catch (error) {
      dispatch({ type: "GET_INTERNSHIP_LETTER_FAILURE", payload: false });
      console.error("Error generating payslip:", error);
      dispatch({ type: "ERROR", payload: "Failed to generate payslip" });
    }
  };
  



  return{
    getEmployeeForGenrateDocument, getInternshipLetter, getJoiningLetter, getRelievingLetter,
    getExperianceLetter
  };

};

export default DocumentViewController;